import React, { useRef, useState } from "react";
import { X } from "lucide-react";

const AddStaffDocumentModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading
}) => {

  const initialFormData = {
    file: null,
    documentType: "",
    documentNumber: "",
    issuedDate: "",
    expiryDate: ""
  };

  const [formData, setFormData] =
    useState(initialFormData);

  const fileInputRef =
    useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileChange = (e) => {

    const file =
      e.target.files[0];

    if (!file) return;

    setFormData({
      ...formData,
      file
    });
  };

  const handleSubmit = () => {

    if (
      !formData.file ||
      !formData.documentType
    ) {
      return;
    }

    const uploadData =
      new FormData();

    uploadData.append(
      "file",
      formData.file
    );

    uploadData.append(
      "document_type",
      formData.documentType
    );

    uploadData.append(
      "document_number",
      formData.documentNumber
    );

    uploadData.append(
      "issued_date",
      formData.issuedDate
    );

    uploadData.append(
      "expiry_date",
      formData.expiryDate
    );

    onSubmit(uploadData);

    setFormData(initialFormData);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleClose = () => {

    setFormData(initialFormData);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    onClose();
  };

  if (!isOpen) return null;

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-6">

      <div className="w-full max-w-[620px] rounded-2xl bg-white shadow-2xl overflow-hidden flex flex-col">

        {/* Header */}

        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-5">

          <h2 className="text-xl font-semibold">
            Upload Staff Document
          </h2>

          <button
            onClick={handleClose}
            className="rounded-lg p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
          >
            <X size={20} />
          </button>

        </div>

        {/* Body */}

        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5">

          {/* File */}

          <div>

            <label className="block text-sm font-medium mb-2">
              Choose File
            </label>

            <input
              ref={fileInputRef}
              type="file"
              onChange={handleFileChange}
              className="w-full rounded-xl border border-gray-300 px-4 py-2.5"
            />

            {formData.file && (

              <p className="mt-2 text-sm text-gray-600">

                Selected :

                {" "}

                <span className="font-medium">

                  {formData.file.name}

                </span>

              </p>

            )}

          </div>

          {/* Document Type */}

          <div>

            <label className="block text-sm font-medium mb-2">

              Document Type

              <span className="text-red-500">
                {" "}*
              </span>

            </label>

            <input
              type="text"
              name="documentType"
              value={formData.documentType}
              onChange={handleChange}
              placeholder="Enter Document Type"
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />

          </div>

          {/* Document Number */}

          <div>

            <label className="block text-sm font-medium mb-2">
              Document Number
            </label>

            <input
              type="text"
              name="documentNumber"
              value={formData.documentNumber}
              onChange={handleChange}
              placeholder="Enter Document Number"
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />

          </div>

          {/* Issued Date */}

          <div>

            <label className="block text-sm font-medium mb-2">
              Issued Date
            </label>

            <input
              type="date"
              name="issuedDate"
              value={formData.issuedDate}
              onChange={handleChange}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />

          </div>

          {/* Expiry Date */}

          <div>

            <label className="block text-sm font-medium mb-2">
              Expiry Date
            </label>

            <input
              type="date"
              name="expiryDate"
              value={formData.expiryDate}
              onChange={handleChange}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />

          </div>

        </div>

        {/* Footer */}

        <div className="flex justify-end gap-3 border-t border-gray-200 bg-gray-50 px-6 py-4">

          <button
            onClick={handleClose}
            className="rounded-xl border border-gray-300 bg-white px-5 py-2.5 font-medium text-gray-700 transition hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="rounded-xl bg-blue-600 px-5 py-2.5 font-medium text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading
              ? "Uploading..."
              : "Upload Document"}
          </button>

        </div>

      </div>

    </div>

  );

};

export default AddStaffDocumentModal;